const initialState = {
  fetching: false,
  fetched: false,
  updating: false,
  error: null,
  data: null,
}

let item

export default (state = initialState, action) => {
  switch (action.type) {
    case 'STORY_RESET':
      return initialState

    case 'STORY_FETCH_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'STORY_FETCH_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload.data,
      }

    case 'STORY_FETCH_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }

    case 'BUCKET_LIST_ADD_FULFILLED':
      item = action.payload.data
      return {
        ...state,
        data: {
          ...state.data,
          added_to_bucket_list: item[item.type].added_to_bucket_list,
        },
      }

    case 'BUCKET_LIST_REMOVE_FULFILLED':
      item = action.payload.data
      return {
        ...state,
        data: {
          ...state.data,
          added_to_bucket_list: item[item.type].added_to_bucket_list,
        },
      }

    default:
      return state
  }
}
